module.exports = __webpack_public_path__ + "media/images/floating-hero-a055c2c084c850bd3ce6c6928b4dd9e6.jpg";